import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M26,8.59,20.41,3A3.733,3.733,0,0,0,18,2H7A2.006,2.006,0,0,0,5,4V28a2.006,2.006,0,0,0,2,2H25a2.006,2.006,0,0,0,2-2V11A3.733,3.733,0,0,0,26,8.59ZM19,4.41,24.59,10H19ZM25,28H7V4H17v7a1,1,0,0,0,1,1h7Z"/><path d="M20,18h2a1,1,0,0,0,0-2H20a1,1,0,0,0,0,2Z"/><path d="M20,22h2a1,1,0,0,0,0-2H20a1,1,0,0,0,0,2Z"/><circle cx="12" cy="12" r="2"/><path d="M16,20H10a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z"/><path d="M16,24H10a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z"/><path d="M10,18a1,1,0,0,0,1-1V16h2v1a1,1,0,0,0,2,0V16a2,2,0,0,0-2-2H11a2,2,0,0,0-2,2v1A1,1,0,0,0,10,18Z"/><path d="M20,26h2a1,1,0,0,0,0-2H20a1,1,0,0,0,0,2Z"/>';
export var ProfileOutlineSVG = function ProfileOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ProfileOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ProfileOutlineSVG);